import React, { Component } from "react";
import { Pagination } from "antd";
import { ORDER_LIST_PAGE_SIZE } from "./orderTableCells";

class Paginater extends Component {
  state = {
    currentPage: this.props.defaultCurrent || 1,
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.current != null &&
      this.props.current !== this.state.currentPage
    ) {
      this.setState({ currentPage: this.props.current });
    }
  }

  handleChange = (page) => {
    this.setState({ currentPage: page });
    if (this.props.onChange) {
      this.props.onChange(page);
    }
  };

  render() {
    const { total, defaultCurrent, defaultPageSize, pageSize } = this.props;
    const { currentPage } = this.state;
    const size = pageSize || defaultPageSize || ORDER_LIST_PAGE_SIZE;
    const safeTotal = total || 0;

    if (!safeTotal) {
      return null;
    }

    return (
      <div className="home-order-pagination">
        <Pagination
          total={safeTotal}
          current={currentPage}
          onChange={this.handleChange}
          defaultCurrent={defaultCurrent || 1}
          pageSize={size}
          showTotal={(count, range) =>
            `${range[0]}–${range[1]} of ${count} orders`
          }
        />
      </div>
    );
  }
}

export default Paginater;
